import dayjs from "dayjs";

export const DateCellRenderer = (value) => {
  const date = new Date(value);
  return <div>{dayjs(date).format("MM-DD-YYYY")}</div>;
};
